/* LB Update 223: Sprachpfad ('/', '/en/', '/nl/') und kurze Texte je Sprache fuer die Skripte in dieser Datei. */
function lbRoot(){ var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; return r.charAt(r.length - 1) === '/' ? r : r + '/'; }
function lbText(k){
  var l = (document.documentElement.lang || 'de').toLowerCase().slice(0, 2);
  var T = {
    de: {alle:'Alle anzeigen', alle1:'zeige alle', alle2:'Produkte an'},
    en: {alle:'View all', alle1:'view all', alle2:'products'},
    nl: {alle:'Alles bekijken', alle1:'bekijk alle', alle2:'producten'},
    fr: {alle:'Tout voir', alle1:'voir tous les', alle2:'produits'},
    pl: {alle:'Zobacz wszystko', alle1:'pokaż wszystkie', alle2:'szt.'},
    it: {alle:'Mostra tutto', alle1:'mostra tutti i', alle2:'prodotti'},
    es: {alle:'Ver todo', alle1:'ver todos los', alle2:'productos'}
  };
  return (T[l] || T.de)[k];
}
/* LB Update 102: Gemeinsamer Anlaufpunkt fuer alles, was unterhalb des
   Sichtbereichs passiert. Laeuft erst, wenn der Browser Luft hat - das senkt
   die Blockierzeit beim Laden, ohne dass der Kunde einen Unterschied sieht. */
window.lbWennFrei = function(fn){
  function los(){
    if(window.requestIdleCallback) requestIdleCallback(fn, {timeout: 1800});
    else setTimeout(fn, 200);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', los, {once:true});
  else los();
};

var script_loaded=!1;function loadJSscripts(){if(!script_loaded){observer.disconnect(),script_loaded=!0,document.querySelectorAll("iframe.lazy").forEach(t=>{datasrc=t.dataset.src,null!=datasrc&&(t.src=datasrc)});var t=Array.prototype.slice.call(document.getElementsByTagName("script"));for(i=0;i<t.length;i++)if(null!==t[i].getAttribute("data-src")&&(t[i].setAttribute("src",t[i].getAttribute("data-src")),delete t[i].dataset.src),"text/lazyload"==t[i].getAttribute("type")){for(var e=document.createElement("script"),a=0;a<t[i].attributes.length;a++){var n=t[i].attributes[a];e.setAttribute(n.name,n.value)}e.type="text/javascript",e.innerHTML=t[i].innerHTML,t[i].parentNode&&t[i].parentNode.replaceChild(e,t[i])}var r=document.getElementsByTagName("link");for(i=0;i<r.length;i++)null!==r[i].getAttribute("data-href")&&(r[i].setAttribute("href",r[i].getAttribute("data-href")),delete r[i].dataset.href);document.querySelectorAll('script[type="text/lazymodule"]').forEach(function(s){var m=document.createElement("script");m.type="module";m.textContent=s.textContent;s.parentNode.replaceChild(m,s)}),document.dispatchEvent(new CustomEvent("asyncLazyLoad"))}}var activityEvents=["mousedown","mousemove","keydown","scroll","touchstart","click","keypress","touchmove"];activityEvents.forEach(function(t){window.addEventListener(t,loadJSscripts,!1)}),window.addEventListener?window.addEventListener("load",function(){},!1):window.attachEvent?window.attachEvent("onload",function(){}):window.onload=(t=>{});
/* LB Update 33: Judge.me-Bewertungen laden, sobald sie in die Naehe des Sichtbereichs kommen (1000 px) oder bei der ersten Nutzeraktion */
(function(){var d=document;function go(){var s=d.querySelectorAll('script[data-src*="/judgeme-"]');for(var k=0;k<s.length;k++){var u=s[k].getAttribute("data-src");if(u.indexOf("/assets/loader.js")>-1){s[k].removeAttribute("data-src");s[k].setAttribute("src",u)}}}var t=d.querySelectorAll('.jdgm-widget,.jdgm-all-reviews-page,.jdgm-preview-badge,#judgeme_product_reviews,[class*="jdgm-carousel"]');if(!t.length)return;if(!("IntersectionObserver" in window)){go();return}var io=new IntersectionObserver(function(e){for(var k=0;k<e.length;k++)if(e[k].isIntersecting){io.disconnect();go();return}},{rootMargin:"0px 0px 1000px 0px"});for(var k=0;k<t.length;k++)io.observe(t[k])})();

/* ===== LB Update 76 ===== */
(function(){
  /* 1) Kategorieseite: beim Setzen eines Filters nicht nach unten springen.
        Das Theme scrollt nach jedem Filterwechsel auf den Anfang der Trefferliste.
        Stand man weiter unten, ist das richtig - stand man oben, springt die Seite
        nach unten weg. Deshalb nur noch scrollen, wenn man bereits darunter ist. */
  function filterPatch(){
    try{
      var K = window.theme && window.theme.Collection && window.theme.Collection.prototype;
      if(!K || typeof K.updateScroll !== 'function') return false;   /* noch nicht geladen */
      if(K.__lbKeinSprung) return true;
      var alt = K.updateScroll;
      K.updateScroll = function(animate){
        try{
          var el = document.querySelector('[data-scroll-to]');
          var ziel = el ? el.getBoundingClientRect().top + (window.pageYOffset||0) : 0;
          if((window.pageYOffset||0) <= ziel + 4) return;   /* schon oberhalb -> stehen bleiben */
        }catch(e){}
        return alt.apply(this, arguments);
      };
      K.__lbKeinSprung = true;
      return true;
    }catch(e){ return true; }
  }
  if(!filterPatch()){ var n=0, t=setInterval(function(){ if(filterPatch()||++n>60) clearInterval(t); },150); }

  /* 2) Vorschaubilder links optisch mittig: gleich viel Weiss links und rechts.
        Das Hauptfoto wird in der Hoehe begrenzt und sitzt deshalb mittig in seiner
        Spalte - links davon bleibt Weiss. Die Vorschauleiste wird per transform
        (kein Umbruch, kein Layout-Sprung) in diese freie Flaeche zentriert. */
  function mitte(){
    if(innerWidth < 769) { raeumen(); return; }
    paar('.product__thumbs', function(){
      /* LB Update 79: das AKTIVE Bild nehmen. Vorher lieferte querySelector immer das
         erste Bild - nach dem Klick auf Bild 2/3/4 wurde deshalb mit falschen Massen
         gerechnet und die Vorschauleiste sprang zurueck nach links. */
      var ph=document.querySelector('.product__main-photos')||document;
      return ph.querySelector('.is-selected img')||ph.querySelector('.flickity-slider > :not([aria-hidden="true"]) img')||document.querySelector('.product-image-main img');
    });
    paar('.lb-bdetail__thumbs', function(){ var s=document.querySelector('.lb-bdetail__slide.is-active'); return s; });
  }
  function raeumen(){
    ['.product__thumbs','.lb-bdetail__thumbs'].forEach(function(s){
      var e=document.querySelector(s); if(e) e.style.transform='';
    });
  }
  function paar(sel, holBild){
    var t = document.querySelector(sel); if(!t) return;
    var b = holBild(); if(!b) return;
    var eltern = t.parentElement; if(!eltern) return;
    t.style.transform = '';
    var rT = t.getBoundingClientRect(), rB = b.getBoundingClientRect(), rE = eltern.getBoundingClientRect();
    if(!rT.width || !rB.width) return;
    var frei = rB.left - rE.left;                 /* Platz bis zum sichtbaren Bild */
    if(frei <= rT.width + 2) return;              /* kein Spielraum - nichts tun */
    var dx = Math.round((frei - rT.width) / 2 - (rT.left - rE.left));
    if(dx > 0) t.style.transform = 'translateX(' + dx + 'px)';
  }
  var f = 0, nach = [];
  function planen(){ if(f) return; f = requestAnimationFrame(function(){ f = 0; mitte(); }); }
  /* Nach einem Bildwechsel braucht das Theme einen Moment, bis Groesse und
     aktives Bild stehen - deshalb mehrfach nachrechnen statt nur einmal. */
  function nachrechnen(){ nach.forEach(clearTimeout); nach = [80,260,600,1200].map(function(ms){ return setTimeout(planen, ms); }); planen(); }
  addEventListener('resize', planen, {passive:true});
  addEventListener('load', planen);
  document.addEventListener('variant:change', nachrechnen);
  document.addEventListener('click', function(e){ if(e.target && e.target.closest && e.target.closest('.product__thumbs,.lb-bdetail__thumbs,.product__photo-nav,.flickity-button')) nachrechnen(); }, true);
  document.addEventListener('lb:bundle-render', nachrechnen);
  ['load','loadeddata'].forEach(function(ev){ document.addEventListener(ev, function(e){
    if(e.target && e.target.tagName === 'IMG' && e.target.closest && e.target.closest('.product__photos,.lb-bdetail__main')) planen();
  }, true); });
  if(window.ResizeObserver){
    ['.product-image-main','.lb-bdetail__main'].forEach(function(s){
      var e=document.querySelector(s); if(e) new ResizeObserver(planen).observe(e);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', planen, {once:true}); else planen();
  setTimeout(planen, 400); setTimeout(planen, 1200); setTimeout(planen, 2500);
})();

/* ===== LB Update 81: Ankündigungsbalken anklickbar =====
   - "… bis zum kostenlosen Versand" / Versandkosten-Hinweis -> Kategorie New In
   - "Newsletter anmelden und 10% sparen"                     -> Newsletter-Fenster
   - "Käuferschutz – mit Klarna & Paypal"                      -> Versand & Rückversand */
(function(){
  function ziel(txt){
    if(/kostenlosen\s+Versand|Versandkosten\s+werden|free\s+shipping|shipping\s+is\s+calculated|gratis\s+verzending|verzendkosten\s+worden|envoi\s+gratuit|frais\s+d.exp[eé]dition|darmow\S*\s+wysy[lł]k|koszty\s+wysy[lł]ki|spedizione\s+gratuita|spese\s+di\s+spedizione|env[ií]o\s+gratuito|gastos\s+de\s+env[ií]o/i.test(txt)) return {url:lbRoot()+'collections/new-in'};
    if(/Newsletter/i.test(txt))                                   return {popup:true};
    if(/Käuferschutz|Kauferschutz|buyer\s+protection|kopersbescherming|protection\s+des\s+acheteurs|ochrona\s+kupuj|protezione\s+acquirent|protecci[oó]n\s+del\s+comprador/i.test(txt))               return {url:lbRoot()+'pages/versand-ruckversand'};
    return null;
  }
  function nlFenster(){ return document.querySelector('[id^="NewsletterPopup-"]'); }
  function newsletterZu(){
    var m = nlFenster(); if(!m) return;
    m.classList.remove('modal--is-active');
    document.documentElement.classList.remove('modal-open');
    document.body.classList.remove('modal-open');
  }
  /* LB Update 291 (Auftrag A07): Zustaendig fuers Oeffnen ist theme.NewsletterPopup (Ereignis reminder:openNewsletter, wie Blase und
     Kopfleiste in lb-header-tools.js). Der Optimizer loest kein eigenes modalOpen mehr aus und oeffnet das Fenster nur noch selbst,
     wenn das Theme es nicht kennt. */
  function themeKenntFenster(){
    try{
      return !!(document.querySelector('[data-section-type="newsletter-popup"]') && window.theme && theme.Modals && theme.sections &&
        theme.sections.instances && theme.sections.instances.some(function(x){ return x.type === 'newsletter-popup'; }));
    }catch(e){ return false; }
  }
  function newsletterAuf(){
    var m = nlFenster(); if(!m) return false;
    if(m.classList.contains('modal--is-active')) return true;
    if(themeKenntFenster()){
      document.dispatchEvent(new CustomEvent('reminder:openNewsletter', {bubbles:true}));
      return true;
    }
    if(!m.classList.contains('modal--is-active')){
      m.classList.add('modal--is-active');
      document.documentElement.classList.add('modal-open');
      document.body.classList.add('modal-open');
      /* Schliessen selbst sicherstellen, falls das Theme das Fenster noch nicht kennt. */
      if(!m.dataset.lbZu){
        m.dataset.lbZu = '1';
        m.addEventListener('click', function(ev){
          if(ev.target === m || (ev.target.closest && ev.target.closest('.modal__close,.js-modal-close'))) newsletterZu();
        });
        document.addEventListener('keydown', function(ev){ if(ev.key === 'Escape') newsletterZu(); });
      }
    }
    return true;
  }
  document.addEventListener('click', function(e){
    var s = e.target && e.target.closest && e.target.closest('.announcement-slider__slide');
    if(!s) return;
    var z = ziel(s.textContent || '');
    if(!z) return;
    e.preventDefault(); e.stopPropagation();
    if(z.popup){
      /* LB Update 291 (Auftrag A07): Banner-Link auf /pages/newsletter oeffnet schon lb-header-tools.js - hier nicht ein zweites Mal. */
      if(e.target.closest('.announcement-link[href$="/pages/newsletter"]') && themeKenntFenster()) return;
      if(!newsletterAuf()) location.href = lbRoot()+'pages/contact'; return;
    }
    location.href = z.url;
  }, true);
  function markieren(){
    document.querySelectorAll('.announcement-slider__slide').forEach(function(s){
      if(ziel(s.textContent || '')) s.style.cursor = 'pointer';
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', markieren, {once:true});
  else markieren();
  setTimeout(markieren, 800); setTimeout(markieren, 2500);
})();

/* LB Update 84: Leere Absaetze und Zeilenumbrueche am Anfang und Ende der
   Info- und Rechtstexte ausblenden und den ersten/letzten sichtbaren Abschnitt
   markieren. Reines CSS reicht nicht, weil die leeren Absaetze ein geschuetztes
   Leerzeichen enthalten und damit nicht als ":empty" gelten. Es werden nur
   Klassen gesetzt, der Seiteninhalt selbst bleibt unveraendert. */
(function(){
  'use strict';
  if(!document.body || !document.body.classList.contains('template-page')) return;
  function leer(el){
    if(!el || el.nodeType !== 1) return false;
    if(el.tagName === 'BR') return true;
    if(!/^(P|DIV|SPAN)$/.test(el.tagName)) return false;
    if(el.querySelector('img,iframe,svg,video,input,button,table')) return false;
    return (el.textContent || '').replace(/[\s ]+/g, '') === '';
  }
  /* richtung: -1 = von hinten, 1 = von vorne */
  function trimmen(box, richtung, tiefe){
    if(!box || tiefe > 6) return null;
    var k = [].slice.call(box.children);
    if(richtung < 0) k.reverse();
    for(var i = 0; i < k.length; i++){
      var el = k[i];
      if(getComputedStyle(el).display === 'none') continue;
      if(leer(el)){ el.classList.add('lb-leer'); continue; }
      if(el.children.length && !/^(P|H1|H2|H3|H4|H5|LI|TABLE|UL|OL)$/.test(el.tagName)){
        var tief = trimmen(el, richtung, tiefe + 1);
        return tief || el;
      }
      return el;
    }
    return null;
  }
  function saeubern(){
    [].forEach.call(document.querySelectorAll('.page-content .rte'), function(rte){
      var ende = trimmen(rte, -1, 0);
      var anfang = trimmen(rte, 1, 0);
      if(ende) ende.classList.add('lb-letzt');
      if(anfang) anfang.classList.add('lb-erst');
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', saeubern, {once:true});
  else saeubern();
  setTimeout(saeubern, 600);
})();

/* LB Update 87: Im Farbfilter steht "Mehrfarbig" ganz vorne. Die Liste ist
   inline-block, deshalb laesst sich die Reihenfolge nicht per CSS aendern –
   der Eintrag wird im Seitengeruest nach vorne gestellt. Die Filterliste wird
   bei jedem Filterwechsel neu geladen, darum die Ueberwachung. */
(function(){
  'use strict';
  function vor(){
    var listen = document.querySelectorAll('.tag-list--swatches');
    for(var i = 0; i < listen.length; i++){
      var ul = listen[i];
      var sw = ul.querySelector('.color-swatch--mehrfarbig');
      if(!sw) continue;
      var li = sw.closest('li');
      if(li && ul.firstElementChild !== li) ul.insertBefore(li, ul.firstElementChild);
    }
  }
  var wartet = false;
  function gleich(){
    if(wartet) return;
    wartet = true;
    requestAnimationFrame(function(){ wartet = false; vor(); });
  }
  function start(){
    vor();
    var ziele = document.querySelectorAll('#FilterDrawer,#CollectionSidebar,.collection-filter,#CollectionAjaxResult');
    if(!ziele.length) ziele = [document.body];
    var beo = new MutationObserver(gleich);
    for(var i = 0; i < ziele.length; i++) beo.observe(ziele[i], {childList:true, subtree:true});
  }
  window.lbWennFrei(start);
  setTimeout(vor, 700); setTimeout(vor, 2000);
})();

/* LB Update 92: Weisser Abstand links und rechts im Footer gleich gross.
   Die Spalten sitzen zwar symmetrisch, die Links in der letzten Spalte sind
   aber kuerzer als die Spalte breit ist – dadurch wirkt rechts viel mehr Platz.
   Gemessen wird deshalb die tatsaechliche Textkante (nicht der Spaltenkasten),
   und das Raster wird um die halbe Differenz nach rechts geschoben. Die
   Spaltenbreiten bleiben dabei unveraendert. Nur am Desktop. */
(function(){
  'use strict';
  function kanten(el){
    var L = Infinity, R = -Infinity;
    var lauf = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false), n;
    while((n = lauf.nextNode())){
      if(!(n.nodeValue || '').trim()) continue;
      var rg = document.createRange();
      rg.selectNodeContents(n);
      var rects = rg.getClientRects();
      for(var i = 0; i < rects.length; i++){
        if(rects[i].width < 1) continue;
        if(rects[i].left < L) L = rects[i].left;
        if(rects[i].right > R) R = rects[i].right;
      }
    }
    return {L:L, R:R};
  }
  function messen(){
    var f = document.querySelector('.site-footer');
    if(!f) return;
    var g = f.querySelector('.page-width > .grid');
    if(!g) return;
    var breit = document.documentElement.clientWidth;
    if(breit < 769){ f.style.setProperty('--lb-footer-shift', '0px'); return; }
    f.style.setProperty('--lb-footer-shift', '0px');
    var k = kanten(g);
    if(!isFinite(k.L) || !isFinite(k.R)) return;
    var links = k.L, rechts = breit - k.R;
    var v = Math.round((rechts - links) / 2);
    if(!(v > 0)) v = 0;
    if(v > 300) v = 300;
    f.style.setProperty('--lb-footer-shift', v + 'px');
  }
  var t;
  function spaeter(){ clearTimeout(t); t = setTimeout(messen, 120); }
  window.lbWennFrei(messen);
  window.addEventListener('resize', spaeter);
  window.addEventListener('load', spaeter);
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(spaeter);
  setTimeout(messen, 900); setTimeout(messen, 2500);
})();

/* LB Update 93 / 97: Wechselnde Kategorien.
   Auf allen Seiten ausser der Startseite werden die Kategorie-Bloecke ueber den
   Bewertungen durch eine Kategorie ersetzt, die zu den zuletzt angesehenen
   Produkten passt. Grundlage ist der Verlauf, den der Shop ohnehin im Browser
   speichert (Klaviyo legt dort die Kategorien jedes angesehenen Produkts ab).
   Nur Kategorien mit mindestens 10 Produkten. Gibt es mehrere Bloecke auf einer
   Seite, bekommt jeder eine andere Kategorie. Ohne Verlauf wird zwischen
   Bestseller, Sale und Neuheiten gewechselt. Alles rein im Browser, keine
   neuen Daten, kein Tracking. */
(function(){
  'use strict';
  var MINDEST = 5;   /* Sascha: Schuhe (7 Produkte) sollen mitrotieren. */
  /* LB Update 111 (Wunsch Sascha): In den Rechtstext-Abschnitten standen 20 Karten
     in einer seitlich schiebbaren Reihe - viel zu viel zum Wischen. Hoechstens acht
     Produktkarten, danach kommt die milchige Kachel "zeige alle N Produkte an".
     Acht teilt sich sauber durch zwei (Handy) und vier (Desktop), es bleibt also
     keine halbe Reihe stehen. Abschnitte, die von Haus aus weniger zeigen
     (Produktseite: vier), bleiben unveraendert. */
  var MAX_KARTEN = 8;
  var TECHNISCH = /\(auto\)|e-?mail|^sku$|^sortiment$|^discount$|^ean\d*$|chatgpt|shop the look|featured collection|all products/i;
  var OHNE_VERLAUF = ['bestseller', 'sale', 'new-in'];
  var LETZTE = 'lbKatZuletzt';

  /* LB Update 291 (Audit S1-032): ungenutzte Funktion verlaufKategorien() entfernt (nirgends aufgerufen, nur lokal in dieser IIFE; Rueckbau: Funktion aus dem Stand vor Update 291 wieder einsetzen). */

  /* LB Update 223 (Sascha/SEO): Auf /en und /nl kamen hier deutsche Kategorienamen, deutsche Links
     (ohne /en bzw. /nl) und deutsche Karten. Jetzt: Auswahl wie bisher ueber die deutsche Liste
     (gleiche Handles in allen Sprachen), Karten/Links mit Sprachpfad, Ueberschrift in der Sprache
     der Seite (zweite Liste /en/collections.json bzw. /nl/collections.json, nur Titel je Handle). */
  var KAT_KEY = 'lbKatKarte2' + (lbRoot() === '/' ? '' : lbRoot());
  function karteMerken(m){ try { sessionStorage.setItem(KAT_KEY, JSON.stringify(m)); } catch(e){} }
  function kategorienHolen(fertig){
    try {
      var c = sessionStorage.getItem(KAT_KEY);
      if(c){
        var vor = JSON.parse(c);
        if(vor && Object.keys(vor).length > 1) return fertig(vor);
        sessionStorage.removeItem(KAT_KEY);
      }
    } catch(e){}
    fetch('/collections.json?limit=250', {credentials:'same-origin'})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(d){
        var m = {};
        if(d && d.collections) d.collections.forEach(function(c){
          if(TECHNISCH.test(c.title)) return;
          if((c.products_count || 0) < MINDEST) return;
          m[String(c.title).toLowerCase()] = {handle:c.handle, titel:c.title, anzahl:(c.products_count || 0)};
        });
        if(lbRoot() === '/' || !Object.keys(m).length){
          if(Object.keys(m).length) karteMerken(m);
          return fertig(m);
        }
        /* Titel in der Sprache der Seite nachtragen (Handles sind in allen Sprachen gleich). */
        return fetch(lbRoot() + 'collections.json?limit=250', {credentials:'same-origin'})
          .then(function(r2){ return r2.ok ? r2.json() : null; })
          .then(function(d2){
            var t = {};
            if(d2 && d2.collections) d2.collections.forEach(function(c2){ t[c2.handle] = c2.title; });
            for(var k2 in m){ if(t[m[k2].handle]) m[k2].titelL = t[m[k2].handle]; }
            karteMerken(m); fertig(m);
          })
          .catch(function(){ fertig(m); });
      })
      .catch(function(){ fertig({}); });
  }

  function mischen(a){
    for(var i = a.length - 1; i > 0; i--){
      var j = Math.floor(Math.random() * (i + 1)), t = a[i];
      a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  var FAMILIEN = [
    ['strick', /strick|cardigan|pullover|pulli|westen|jacke|mantel|blazer/i],
    ['oben',   /bluse|shirt|top|body|longsleeve|oberteil/i],
    ['unten',  /hose|jeans|legging|rock|short|cargo/i],
    ['kleid',  /kleid|jumpsuit|overall/i]
  ];
  /* Zu welcher Warengruppe gehoert die Kategorie? Damit nicht zweimal
     hintereinander etwas aus derselben Ecke erscheint. */
  function familie(titel){
    for(var i = 0; i < FAMILIEN.length; i++){
      if(FAMILIEN[i][1].test(titel || '')) return FAMILIEN[i][0];
    }
    return 'rest';
  }
  function zuletzt(){
    try {
      var d = JSON.parse(sessionStorage.getItem(LETZTE) || '{}');
      if(Object.prototype.toString.call(d) === '[object Array]') d = {h:d, f:[]};
      return {h: d.h || [], f: d.f || []};
    } catch(e){ return {h:[], f:[]}; }
  }
  function zuletztMerken(handles, fam){
    var v = zuletzt();
    try {
      sessionStorage.setItem(LETZTE, JSON.stringify({
        h: v.h.concat(handles).slice(-8),
        f: v.f.concat(fam).slice(-2)
      }));
    } catch(e){}
  }

  function kandidaten(m, jetzigerPfad){
    var vorige = zuletzt();
    /* Jede Kategorie des Sortiments hat dieselbe Chance - sonst kommen immer
       wieder dieselben Ecken (Jacken, Strickwaren) dran. */
    var topf = [];
    for(var n in m) topf.push(m[n]);
    /* Kategorie der aktuellen Seite, die letzten acht gezeigten und die beiden
       zuletzt benutzten Warengruppen weglassen. */
    var frei = topf.filter(function(e3){
      if((lbRoot() + 'collections/' + e3.handle) === jetzigerPfad) return false;
      if(vorige.h.indexOf(e3.handle) >= 0) return false;
      return vorige.f.indexOf(familie(e3.titel)) < 0;
    });
    /* Wird es zu eng, erst die Warengruppen-Sperre lockern, dann den Verlauf. */
    if(frei.length < 2){
      frei = topf.filter(function(e4){
        if((lbRoot() + 'collections/' + e4.handle) === jetzigerPfad) return false;
        return vorige.h.indexOf(e4.handle) < 0;
      });
    }
    if(frei.length < 2) frei = topf.filter(function(e5){ return (lbRoot() + 'collections/' + e5.handle) !== jetzigerPfad; });
    var gesehen = {}, liste = [];
    mischen(frei).forEach(function(e5){
      if(gesehen[e5.handle]) return;
      gesehen[e5.handle] = 1; liste.push(e5);
    });
    if(!liste.length){
      OHNE_VERLAUF.forEach(function(h){
        for(var n2 in m){ if(m[n2].handle === h){ liste.push(m[n2]); break; } }
      });
    }
    return liste;
  }

  /* LB Update 108: Klappt eine Kategorie nicht (Netz, Umleitung, zu wenig Karten),
     wird der naechste Vorschlag aus der Liste genommen statt aufzugeben. */
  function einsetzen(sektion, wahl, reserve, wennFertig){
    var gitter = sektion.querySelector('.grid');
    if(!gitter) return;
    /* LB Update 109: Im Raster stehen nicht nur Produktkarten. Am Ende sitzt die
       milchige Kachel "zeige alle N Produkte an" (.grid__item--view-all), auf
       dem Desktop zusaetzlich .lb-viewall-wrap, dahinter ein kleines Skript,
       das die Kachelhoehe angleicht. Die wurden bisher mit ersetzt und waren
       danach weg. Jetzt werden sie herausgenommen, nur die Produktkarten
       getauscht, und danach wieder angehaengt. */
    var zusatz = [].slice.call(gitter.children).filter(function(k){
      return !(k.classList && k.classList.contains('grid-product'));
    });
    var vorher = gitter.querySelectorAll('.grid__item.grid-product').length || 4;
    if(vorher > MAX_KARTEN) vorher = MAX_KARTEN;
    /* Immer ein Vielfaches von vier: am Handy zwei je Reihe, am Desktop vier.
       Die 404-Seite zeigt zum Beispiel fuenf Karten - daraus werden vier. */
    vorher = Math.floor(vorher / 4) * 4;
    if(vorher < 4) vorher = 4;
    function weiter(){
      if(reserve && reserve.length){
        var n = reserve.shift();
        if(n && n.handle) einsetzen(sektion, n, reserve, wennFertig);
      }
    }
    fetch(lbRoot() + 'collections/' + wahl.handle + '?view=lbkarten', {credentials:'same-origin'})
      .then(function(r){ return r.ok ? r.text() : null; })
      .then(function(html){
        if(!html || html.indexOf('grid__item') < 0) return weiter();
        /* Weniger als vier Karten sieht nach Luecke aus - dann die naechste nehmen. */
        var probe = document.createElement('div');
        probe.innerHTML = html;
        if(probe.querySelectorAll('.grid__item').length < 4) return weiter();
        if(vorher < 4) vorher = 4;
        gitter.innerHTML = html;
        /* So viele Produktkarten wie vorher, damit das Raster gleich bleibt.
           Liefert die Kategorie weniger, wird auf ein Vielfaches von vier
           gekuerzt - am Handy stehen zwei Karten nebeneinander, am Desktop
           vier. So bleibt keine halbe Reihe uebrig. */
        var karten = gitter.querySelectorAll('.grid__item');
        var ziel = vorher;
        if(karten.length < vorher){
          ziel = Math.floor(karten.length / 4) * 4;
          if(ziel < 4) ziel = 4;
        }
        for(var i = ziel; i < karten.length; i++) karten[i].parentNode.removeChild(karten[i]);
        /* Die milchige Kachel und das Hoehen-Skript wieder ans Ende. */
        zusatz.forEach(function(z){
          if(z.querySelectorAll){
            z.querySelectorAll('a[href*="/collections/"], a[href*="/products/"]').forEach(function(lk){
              lk.setAttribute('href', lbRoot() + 'collections/' + wahl.handle);
            });
            var txt = z.querySelector('.lb-see-all__text');
            if(txt && wahl.anzahl){
              txt.innerHTML = lbText('alle1') + '<br>' + wahl.anzahl + ' ' + lbText('alle2');
            }
          }
          gitter.appendChild(z);
        });
        var t = sektion.querySelector('.section-header__title');
        if(!t){
          /* Das Theme zeichnet die Kopfzeile nur, wenn im Abschnitt ein Titel
             eingetragen ist. Fehlt sie (Gutschein, Produktseite, Bundles),
             wird sie hier angelegt. */
          var kopf = document.createElement('div');
          kopf.className = 'page-width';
          kopf.innerHTML = '<div class="section-header"><h2 class="section-header__title h2"></h2></div>';
          var ziel = gitter.closest('.page-width') || gitter.parentNode;
          if(ziel && ziel.parentNode){
            ziel.parentNode.insertBefore(kopf, ziel);
            t = kopf.querySelector('.section-header__title');
          }
        }
        if(t) t.textContent = wahl.titelL || wahl.titel;
        var a = sektion.querySelector('.section-header__link');
        if(a){ a.setAttribute('href', lbRoot() + 'collections/' + wahl.handle);
               a.setAttribute('aria-label', lbText('alle') + ': ' + (wahl.titelL || wahl.titel)); }
        sektion.querySelectorAll('a[href*="/collections/"]').forEach(function(x){
          if(!x.closest('.grid__item')) x.setAttribute('href', lbRoot() + 'collections/' + wahl.handle);
        });
        sektion.setAttribute('data-lb-kat', wahl.handle);
        /* Das Hoehen-Skript der milchigen Kachel haengt am resize-Ereignis. */
        try { window.dispatchEvent(new Event('resize')); } catch(e){}
        setTimeout(function(){ try { window.dispatchEvent(new Event('resize')); } catch(e){} }, 500);
        if(wennFertig) wennFertig(wahl);
      })
      .catch(function(){ weiter(); });
  }

  function start(){
    if(document.body.classList.contains('template-index')) return;   /* Startseite bleibt */
    var alle = [].slice.call(document.querySelectorAll(
      '#MainContent .shopify-section[id*="lb_kategorie"],' +
      '#MainContent .shopify-section[id*="lb-kategorie"],' +
      '#MainContent .shopify-section[id*="featured_collection"],' +
      '#MainContent .shopify-section[id*="featured-collection"]'));
    var sektionen = alle.filter(function(s){
      if(s.closest('#FilterDrawer,.drawer,.lb-suche,#LBWieder,#CartDrawer')) return false;
      /* LB Update 116: "featured_collections" in der MEHRZAHL ist ein anderer
         Abschnitt - dort stehen Kategorie-Kacheln, keine Produkte. Der wurde
         bisher mitgenommen und mit Produktbildern ueberschrieben. Ebenso
         ausgenommen: die Kategorieliste selbst, die Suchergebnisse und der
         Block "Zuletzt angesehen". */
      var kennung = String(s.id || '');
      if(/featured[_-]collections/i.test(kennung)) return false;
      if(/main-collection|main-search|list-collections|recently-viewed|lb_zuletzt|lb-zuletzt/i.test(kennung)) return false;
      /* Nur Abschnitte, die wirklich Produktkarten zeigen. */
      var karten = s.querySelectorAll('.grid .grid__item.grid-product');
      if(karten.length < 2) return false;
      /* Kategorie-Kacheln erkennen: wenn im Raster Kategoriebilder stecken, Finger weg. */
      if(s.querySelector('.grid .grid__item .collection-item')) return false;
      return true;
    });
    if(!sektionen.length) return;
    kategorienHolen(function(m){
      var liste = kandidaten(m, location.pathname);
      if(!liste.length) return;
      sektionen.forEach(function(s, i){
        var wahl = liste[i % liste.length];
        if(!wahl || !wahl.handle) return;
        var reserve = liste.slice(i + 1).concat(liste.slice(0, i)).slice(0, 4);
        einsetzen(s, wahl, reserve, function(genommen){
          fertig = true;
          zuletztMerken([genommen.handle], [familie(genommen.titel)]);
        });
      });
    });
  }
  /* LB Update 108: Bei etwa jedem zehnten Aufruf kam der Abschnitt zu spaet in die
     Seite oder die Kategorieliste liess sich nicht laden - dann blieb die
     Kategorie stehen wie sie war, teils ohne Ueberschrift. Deshalb wird bis zu
     dreimal nachgefasst, bis wirklich eine Kategorie gesetzt ist. */
  var fertig = false, versuche = 0;
  function nachfassen(){
    if(fertig || versuche >= 3) return;
    versuche++;
    try { start(); } catch(e){}
    setTimeout(nachfassen, 1400);
  }
  window.lbWennFrei(nachfassen);
})();

/* LB Update 96: Browser-Meldungen im Shop-Stil.
   Shopify und das Theme zeigen Hinweise wie "Aufgrund der Verfuegbarkeit wurden
   nur 2 Artikel zu deinem Warenkorb hinzugefuegt" ueber window.alert – das ist
   der graue Kasten mit "Auf lisas-boutique.de wird Folgendes angezeigt".
   Stattdessen erscheint jetzt ein Fenster im Shop-Stil. Geht dabei etwas schief,
   wird die urspruengliche Browser-Meldung benutzt, damit der Hinweis nie
   verloren geht. confirm() und prompt() bleiben unangetastet. */
(function(){
  'use strict';
  var alt = window.alert;
  if(typeof alt !== 'function') return;
  var box, textEl, btn, vorher;

  function bauen(){
    if(box) return box;
    box = document.createElement('div');
    box.className = 'lb-hinweis';
    box.hidden = true;
    box.setAttribute('role', 'alertdialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-labelledby', 'lbHinweisTitel');
    box.setAttribute('aria-describedby', 'lbHinweisText');
    var lbSpr = (document.documentElement.lang || 'de').slice(0, 2);
    box.innerHTML = '<div class="lb-hinweis__box">'
      + '<p class="lb-hinweis__titel" id="lbHinweisTitel">' + ({en:'Please note',nl:'Let op',fr:'Petite remarque',pl:'Krótka uwaga',it:'Una breve nota',es:'Una nota rápida'}[lbSpr] || 'Kurzer Hinweis') + '</p>'
      + '<p class="lb-hinweis__text" id="lbHinweisText"></p>'
      + '<button type="button" class="lb-hinweis__btn">' + ({en:'OK',nl:'Oké',fr:'Compris',pl:'Jasne',it:'Ok',es:'Entendido'}[lbSpr] || 'Alles klar') + '</button></div>';
    textEl = box.querySelector('.lb-hinweis__text');
    btn = box.querySelector('.lb-hinweis__btn');
    btn.addEventListener('click', zu);
    box.addEventListener('click', function(e){ if(e.target === box) zu(); });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape') zu();
      /* AS-01: Fokus im Fenster halten - es gibt nur den einen Knopf */
      else if(e.key === 'Tab' && box && !box.hidden){ e.preventDefault(); btn.focus({preventScroll:true}); }
    });
    document.body.appendChild(box);
    return box;
  }
  function zu(){
    if(!box || box.hidden) return;
    box.hidden = true;
    box.setAttribute('aria-hidden', 'true');
    if(vorher && vorher.focus) { try { vorher.focus({preventScroll:true}); } catch(e){} }
  }
  window.alert = function(text){
    var s = (text === null || text === undefined) ? '' : String(text);
    try {
      if(!document.body) return alt.call(window, s);
      bauen();
      textEl.textContent = s;
      vorher = document.activeElement;
      box.hidden = false;
      box.setAttribute('aria-hidden', 'false');
      btn.focus({preventScroll:true});
    } catch(e){
      try { alt.call(window, s); } catch(e2){}
    }
  };
})();

/* LB Update 105: Zwei Punkte aus der Barrierefreiheits-Pruefung (axe-core).
   1. Der Bewertungs-Schieber von Judge.me laesst sich mit der Maus seitlich
      schieben, war aber mit der Tastatur nicht erreichbar. Er bekommt deshalb
      tabindex und eine Bezeichnung - sichtbar aendert sich nichts.
   2. Das Ankuendigungsband oben steht ausserhalb von Kopf- und Hauptbereich.
      Vorlese-Programme finden es dadurch schlecht. Es bekommt eine eigene
      Bereichs-Kennzeichnung mit Namen.
   Beides nur, wenn noch nichts gesetzt ist. */
(function(){
  'use strict';
  /* LB Update 250 (H2): Bezeichnungen je Sprache der Seite (vorher fest deutsch auch auf /en und /nl,
     Pruefbericht 249 F06). Rueckfall Deutsch, unveraendert. */
  var lbA11yL = (document.documentElement.lang || 'de').toLowerCase().slice(0, 2);
  var lbA11yT = ({
    en: {bew: 'Customer reviews, scrollable sideways', ank: 'Announcements'},
    nl: {bew: 'Klantreviews, zijwaarts scrollbaar', ank: 'Aankondigingen'},
    fr: {bew: 'Avis clients, défilement horizontal', ank: 'Annonces'},
    pl: {bew: 'Opinie klientów, przewijane w bok', ank: 'Ogłoszenia'},
    it: {bew: 'Recensioni dei clienti, scorrimento laterale', ank: 'Annunci'},
    es: {bew: 'Reseñas de clientes, desplazables en horizontal', ank: 'Anuncios'}
  })[lbA11yL] || {bew: 'Kundenbewertungen, seitlich verschiebbar', ank: 'Ankuendigungen'};
  function richten(){
    var s = document.querySelectorAll('.jdgm-carousel__item-container, .jdgm-carousel-wrapper .jdgm-carousel');
    for(var i = 0; i < s.length; i++){
      var el = s[i];
      if(el.hasAttribute('tabindex')) continue;
      if(el.scrollWidth <= el.clientWidth + 2) continue;
      el.setAttribute('tabindex', '0');
      if(!el.getAttribute('role')) el.setAttribute('role', 'region');
      if(!el.getAttribute('aria-label')) el.setAttribute('aria-label', lbA11yT.bew);
    }
    var a = document.querySelector('.announcement-bar, [class*="announcement-slider"]');
    if(a){
      var box = a.closest('.shopify-section') || a;
      if(!box.getAttribute('role') && !box.closest('header,main,nav,footer')){
        box.setAttribute('role', 'region');
        box.setAttribute('aria-label', lbA11yT.ank);
      }
    }
  }
  window.lbWennFrei(richten);
  setTimeout(richten, 1500);
  setTimeout(richten, 4000);
})();

/* LB Update 117: Zwei Punkte aus der Messung ueber alle Seitentypen.
   1. Cookie-Seite: Solange die Cookie-Erklaerung fehlt, blendet das Stylesheet
      alles darunter aus, damit beim Nachladen nichts verspringt. Falls Cookiebot
      gar nicht laedt (Werbeblocker), wird hier nach sechs Sekunden freigegeben.
   2. Bild-Links ohne Beschriftung (z. B. das Instagram-Bild auf "Ueber uns")
      bekommen eine Bezeichnung, damit Vorlese-Programme sie benennen koennen.
      Sichtbar aendert sich nichts. */
(function(){
  'use strict';
  /* Hinweis fuer spaeter: Auf der Cookie-Seite entsteht ein Layoutsprung von 0,70,
     weil Cookiebot die Erklaerung (ueber 11.000 px) erst nach dem Laden einfuegt.
     Ein Versuch, den Rest der Seite so lange auszublenden, hat den Wert NICHT
     veraendert (dreimal 0,701 vorher wie nachher) und wurde deshalb wieder
     entfernt - kein Nutzen, aber das Risiko einer halb leeren Rechtstextseite.
     Der Sprung liegt in Cookiebots eigener Darstellung und ist von aussen
     nicht zu beheben. Gemessen am 20.09.2026. */

  function lbSocLabel(n){
    var p = {de:'bei', en:'on', nl:'op', fr:'sur', pl:'na', it:'su', es:'en'};
    var sp = (document.documentElement.lang || 'de').toLowerCase().slice(0, 2);
    return 'Lisa’s Boutique ' + (p[sp] || p.de) + ' ' + n;
  }
  var DIENSTE = [
    [/instagram\.com/i, lbSocLabel('Instagram')],
    [/facebook\.com/i,  lbSocLabel('Facebook')],
    [/tiktok\.com/i,    lbSocLabel('TikTok')],
    [/pinterest\./i,    lbSocLabel('Pinterest')],
    [/youtube\.com|youtu\.be/i, lbSocLabel('YouTube')]
  ];
  function benennen(){
    var a = document.querySelectorAll('#MainContent a:not([aria-label]):not([title])');
    for(var i = 0; i < a.length; i++){
      var lk = a[i];
      if((lk.textContent || '').trim()) continue;
      var bild = lk.querySelector('img');
      if(!bild || (bild.getAttribute('alt') || '').trim()) continue;
      var ziel = lk.getAttribute('href') || '', name = '';
      for(var k = 0; k < DIENSTE.length; k++){
        if(DIENSTE[k][0].test(ziel)){ name = DIENSTE[k][1]; break; }
      }
      if(!name){
        /* sonst die naechstgelegene Ueberschrift nehmen */
        var box = lk.closest('.feature-row, .grid__item, section, .shopify-section');
        var u = box ? box.querySelector('h1,h2,h3,.h1,.h2,.h3') : null;
        if(u && (u.textContent || '').trim()) name = u.textContent.trim().slice(0, 70);
      }
      if(name) lk.setAttribute('aria-label', name);
    }
  }
  window.lbWennFrei(benennen);
  setTimeout(benennen, 2500);
})();

/* LB Update 120: Ueberschriften-Reihenfolge in Rechtstexten.
   Auf der Datenschutzseite ist die erste Ueberschrift im Text ein h3, danach
   folgen lauter h2. Damit ueberspringt die Gliederung eine Ebene - axe-core
   meldet "heading-order", und Vorlese-Programme lesen die Struktur falsch vor.
   Hier wird die erste Ueberschrift in ein h2 umgesetzt und bekommt die Klasse
   lb-war-h3, die im Stylesheet exakt das bisherige Aussehen wiederherstellt.
   Der Seitentext im Shopify-Adminbereich bleibt unveraendert. */
(function(){
  'use strict';
  function richten(){
    var texte = document.querySelectorAll('#MainContent .rte');
    for(var i = 0; i < texte.length; i++){
      var rte = texte[i];
      var erste = rte.querySelector('h2,h3,h4');
      if(!erste || erste.tagName !== 'H3') continue;
      /* nur, wenn danach wirklich h2 folgen - sonst ist die Ebene korrekt */
      if(!rte.querySelector('h2')) continue;
      var neu = document.createElement('h2');
      neu.className = (erste.className ? erste.className + ' ' : '') + 'lb-war-h3';
      neu.innerHTML = erste.innerHTML;
      if(erste.id) neu.id = erste.id;
      erste.parentNode.replaceChild(neu, erste);
    }
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', richten, {once:true});
  else richten();
})();

/* LB Update 123: "Entdecke unsere Styles" im Warenkorb mischen.
   Die Karten kommen aus der Kategorie NEW IN und stehen im Theme in fester
   Reihenfolge. Artikel, die schon im Warenkorb liegen, blendet das Theme bereits
   selbst aus - das bleibt so. Neu ist: Die Reihenfolge wird bei jedem Laden der
   Seite und bei jedem Oeffnen der Tasche neu gewuerfelt.
   Erster Durchgang: Die Vorlage wird gemischt, BEVOR das Warenkorb-Skript sie
   einbaut (beide Skripte laufen vor DOMContentLoaded, lb-cart-tools baut erst
   danach auf). Zweiter Durchgang beim Oeffnen: das fertige Karussell wird
   umsortiert und die Punkte darunter passend neu aufgebaut. */
(function(){
  'use strict';
  function mischen(liste){
    for(var i = liste.length - 1; i > 0; i--){
      var j = Math.floor(Math.random() * (i + 1)), t = liste[i];
      liste[i] = liste[j]; liste[j] = t;
    }
    return liste;
  }

  /* 1. Vorlage mischen, bevor sie eingebaut wird */
  var vorlage = document.getElementById('LBNativeStylesTemplate');
  if(vorlage && vorlage.content){
    var spur = vorlage.content.querySelector('.lb-styles-track');
    if(spur){
      var karten = [].slice.call(spur.querySelectorAll('.lb-style-card'));
      if(karten.length > 2) mischen(karten).forEach(function(k){ spur.appendChild(k); });
    }
  }

  /* 2. Beim Oeffnen der Tasche neu mischen */
  function punkteNeu(abschnitt){
    var spur2 = abschnitt.querySelector('.lb-styles-track');
    var punkte = abschnitt.querySelector('.lb-styles-dots');
    if(!spur2 || !punkte) return;
    var sichtbar = [].slice.call(spur2.querySelectorAll('.lb-style-card')).filter(function(k){ return !k.hidden; });
    punkte.replaceChildren();
    sichtbar.forEach(function(k, i){
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'lb-style-dot';
      var t2 = k.querySelector('.lb-style-title');
      b.setAttribute('aria-label', t2 ? t2.textContent : 'Style ' + (i + 1));
      b.setAttribute('aria-current', String(i === 0));
      b.addEventListener('click', function(){
        spur2.scrollTo({left: spur2.scrollLeft + k.getBoundingClientRect().left - spur2.getBoundingClientRect().left,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      });
      punkte.appendChild(b);
    });
    spur2.addEventListener('scroll', function(){
      var start = spur2.getBoundingClientRect().left, nah = 0, weit = Infinity;
      sichtbar.forEach(function(k2, i2){
        var d = Math.abs(k2.getBoundingClientRect().left - start);
        if(d < weit){ weit = d; nah = i2; }
      });
      punkte.querySelectorAll('.lb-style-dot').forEach(function(d2, i3){ d2.setAttribute('aria-current', String(i3 === nah)); });
    }, {passive:true});
  }

  function neuMischen(){
    document.querySelectorAll('.lb-native-styles').forEach(function(ab){
      var spur3 = ab.querySelector('.lb-styles-track');
      if(!spur3) return;
      var k3 = [].slice.call(spur3.querySelectorAll('.lb-style-card'));
      if(k3.length < 3) return;
      mischen(k3).forEach(function(k4){ spur3.appendChild(k4); });
      spur3.scrollLeft = 0;
      punkteNeu(ab);
    });
  }

  /* Auch beim normalen Laden einmal mischen - deckt die Warenkorbseite /cart ab
     und den Fall, dass die Vorlage schon eingebaut war. */
  /* LB Update 208 (Sascha): Das Karussell soll auf derselben Seite gleich bleiben - auch
     wenn die Tasche mehrmals geoeffnet wird. Auswahl und Reihenfolge werden jetzt einmal pro
     Seitenaufruf in snippets/lb-styles-mix.liquid gewuerfelt. Das Nachmischen nach dem Laden
     und bei jedem Oeffnen ist deshalb abgeschaltet (Funktion bleibt fuer den Rueckweg stehen). */
  var lbNachmischen = false;
  if(lbNachmischen){ window.lbWennFrei(neuMischen); setTimeout(neuMischen, 1800); }

  var schublade = document.getElementById('CartDrawer');
  if(schublade){
    var offen = schublade.classList.contains('is-open') || schublade.classList.contains('drawer--is-open');
    new MutationObserver(function(){
      var jetzt = schublade.classList.contains('is-open') || schublade.classList.contains('drawer--is-open');
      if(lbNachmischen && jetzt && !offen) setTimeout(neuMischen, 60);
      offen = jetzt;
    }).observe(schublade, {attributes:true, attributeFilter:['class']});
  }
})();
